import cn from 'classnames'
import { memo } from 'react'

import { Translation } from 'cng-common/features/translations'

import { promotionProductTranslationKey } from '../../configs/translation'
import { resolveProductImageKind } from '../../lib/resolveProductImageKind'
import { OfferTypeMarker } from '../../models'
import { OfferMarkerList } from '../offerMarker'
import { ProductImage } from '../productImage'

import styles from './ProductCard.module.scss'

interface Props {
  imageUrl: string
  markers: readonly OfferTypeMarker[]
  name: string
  productLineCode: string
  /** `null` — nobody reported the stock of this row: the pair is not drawn. */
  stock: number | null
  itemsCount?: number
  badge?: string
  country?: string
  className?: string
}

export const ProductCard = memo<Props>(
  ({ imageUrl, markers, name, productLineCode, stock, itemsCount, badge, className, country }) => {
    return (
      <article className={cn(styles.root, className)}>
        <ProductImage
          className={styles.image}
          src={imageUrl}
          alt={name}
          kind={resolveProductImageKind(name)}
        />

        <div className={styles.info}>
          <h3 className={styles.name} title={name}>
            {name}
          </h3>
          <p className={styles.meta}>
            <span>
              <Translation text={`${promotionProductTranslationKey}-product-line`} span />
              <b className={styles.metaValue}>{productLineCode}</b>
            </span>
            {stock !== null && (
              <span>
                <Translation text={`${promotionProductTranslationKey}-stock`} span />
                <b className={styles.metaValue}>{stock}</b>
              </span>
            )}
            {itemsCount !== undefined && (
              <span>
                Items: <b className={styles.metaValue}>{itemsCount}</b>
              </span>
            )}
          </p>
          {badge && <span className={styles.badge}>{badge}</span>}
        </div>

        {country && <span className={styles.country}>{country}</span>}

        <OfferMarkerList markers={markers} />
      </article>
    )
  }
)

ProductCard.displayName = 'ProductCard'
